export const getMealCount = (products) => {
    if (!products || products.length === 0) {
        return 0;
    }

    return products.reduce((sum, product) => sum + product.amount, 0);
};
